import {Folder, ID, PreviewObject, ToggleProperty} from 'types';
import {CourseEmbedded} from '../course';
import {FileObject} from '../library';

export enum ContentType {
  Local = 'local',
  Youtube = 'youtube',
  Zoom = 'zoom',
}

export interface ContentObject {
  value: {};
  contentType: ContentType;
}

export interface WebinarRecordTime {
  days: number;
}

export enum WebinarStatus {
  Draft = 'draft',
  Private = 'private',
  Public = 'public',
  Ban = 'ban',
}

export interface WebinarAccessSettings {
  courses: CourseEmbedded;
  type: string;
}

export interface WebinarPlug {
  type: 'default' | 'image' | 'video';
  file?: PreviewObject;
}

export interface WebinarPlugs {
  beforePlug: WebinarPlug;
  afterPlug: WebinarPlug;
}

export interface WebinarNotification {
  days: number;
  hours: number;
  minutes: number;
  sms: number;
  email: number;
  courses: CourseEmbedded;
}

export interface WebinarObject {
  id: ID;
  title: string;
  description: string;
  time: number;
  preview?: PreviewObject;
  content?: ContentObject[];
  saveAfter?: boolean;
  recordTime?: ToggleProperty<WebinarRecordTime>;
  date?: Date;
  conferenceId?: string;
  status?: WebinarStatus;
  access?: WebinarAccessSettings;
  plugs?: WebinarPlugs;
  folders?: Folder[];
  prepareMessage?: ToggleProperty<{
    text: string;
  }>;
  beforeNotification?: WebinarNotification;
  summary?: ToggleProperty<{
    pdf: FileObject;
  }>;
  tags?: Folder[];
  link: string;
  live?: boolean;
  userID: ID;
}
